export let config = {
	panel: [
		/** After copying new Data, please check the child-arrays for "categories" and "links"!
		 * - Remove empty fields
		 * - Change '"[' and ']"' to '[' and ']' to activate arrays (strg + h -> correct all)
		 */
		{
			id: 38,
			type: "solution",
			title: {
				en: "Turbocharger",
				de: "Turbocharger",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			description: "",
			links: [],
			engines: [],
			children: [
				{
					id: 1,
					type: "solution",
					title: {
						en: "Everllence Turbocharger Retrofit",
						de: "Everllence Turbocharger Retrofit",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Turbocharger_retrofit.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Retrofitting an existing engine with the latest Everllence turbocharger technology is an effective method of extending its useful life while also improving its performance, economics and environmental impact.  Retrofit your turbocharger and gain up to 12% of the turbocharger efficiency and expect return on investment in 2 years!",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/250522_everllence-ltsa-turbocharger-brochure_final.pdf?sfvrsn=128de8e3_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about Turbocharger Retrofit",
								de: "More about Turbocharger Retrofit",
							},
							url: "https://www.everllence.com/services/portfolio/turbocharger/turbocharger-retrofit",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 47,
					type: "solution",
					title: {
						en: "Turbocharger PLO Upgrade NR34",
						de: "Turbocharger PLO Upgrade NR34",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Turbocharger_retrofit.jpg",
					categories: [
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"This upgrade decreases fuel consumption, exhaust temperatures, and wear on your turbocharger parts. Modify your existing turbocharger with the Turbocharger PLO Upgrade NR34 and boost the efficiency and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 3,
					type: "solution",
					title: {
						en: "Dry and Wet Cleaning for Turbocharger",
						de: "Dry and Wet Cleaning for Turbocharger",
					},
					info: "Applicable for Everllence 32/40CD engines",
					image:
						"/apps/configurators/shared/assets/images/content/Dry_and_wet_cleaning.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Regular and proper turbocharger maintenance ensures peak performance, extends the time between overhauls, and maintains fuel efficiency - neglect can lead to a 5% increase in fuel consumption.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 4,
					type: "solution",
					title: {
						en: "New Sensor Position - Temperature TC inlet Retrofit Kit",
						de: "New Sensor Position - Temperature TC inlet Retrofit Kit",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/New_sensor_position.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Avoid unnecessary alarms from the engine SaCoS Control System with high exhaust gas temperature at TC Inlet and enhance operational efficiency and reliability with our New Sensor Position – Temperature TC inlet Retrofit Kit, designed for all Everllence 32/40 engine types. For more details, our service experts are ready to assist.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 39,
			type: "solution",
			title: {
				en: "Connecting rod & piston",
				de: "Connecting rod & piston",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 5,
					type: "solution",
					title: {
						en: "Low Cavitation Bearings",
						de: "Low Cavitation Bearings",
					},
					info: "Applicable for Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Low_cavitation_Bearings.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlsslichkeit",
						},
					],
					engines: [1],
					description:
						"Improve your Everllence 32/40 engine with our Low Cavitation Bearings. This upgrade minimizes wear rate and cavitation at low loads, ensuring enhanced durability and operational stability. It is an essential investment for prolonging engine lifetime and maintaining peak performance.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 40,
			type: "solution",
			title: {
				en: "Cylinder head",
				de: "Cylinder head",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [0],
			description: "",
			links: [],
			children: [
				{
					id: 6,
					type: "solution",
					title: {
						en: "NIMONIC Exhaust Valve Cone",
						de: "NIMONIC Exhaust Valve Cone",
					},
					info: "Applicable for Everllence 32/40CD engine type",
					image:
						"/apps/configurators/shared/assets/images/content/Nimonic_exhaust_valve_cone.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Elevate your Everllence 32/40CD engine performance with our NIMONIC Exhaust Valve Cone. This upgrade offers superior heat resistance and robustness. It minimizes wear and corrosion risk, ensuring smoother operations and extending Time Before Overhaul (TBO), contributing to lower life cycle costs and enhanced engine reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 7,
					type: "solution",
					title: {
						en: "New Valve Seat Sealing-Ring",
						de: "New Valve Seat Sealing-Ring",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/New_valve_and_sealing_ring.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"The New Valve Seat Sealing-Ring for Everllence 32/40 engines is designed for enhanced valve sealing within the cylinder cover. This innovative upgrade ensures improved reliability and availability by offering superior sealing performance, which is crucial for maintaining engine integrity and efficiency.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 41,
			type: "solution",
			title: {
				en: "Fuel Injection system",
				de: "Fuel Injection system",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 8,
					type: "solution",
					title: {
						en: "MK3 Injection Pump Upgrade",
						de: "MK3 Injection Pump Upgrade",
					},
					info: "Applicable for Everllence 32/40CD engines",
					image: "/apps/configurators/shared/assets/images/content/mk3.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Elevate your Everllence 32/40CD engine with the MK3 Injection Pump Upgrade, engineered for superior performance. This new pump generation provides significantly increased reliability and more than doubles the operating time between engine overhauls. Main benefits: Easy to upgrade, significant reduction of sticking plungers, leakage reuse, state-of-art manufacturing.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "/apps/configurators/shared/assets/pdfs/Everllence FactSheet_Mk3 Pump_32_40.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 42,
			type: "solution",
			title: {
				en: "Automation & engine control system",
				de: "Automation & engine control system",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 9,
					type: "solution",
					title: {
						en: "VIT - Variable Injection Timing",
						de: "VIT - Variable Injection Timing",
					},
					info: "Applicable for Everllence 32/40CD and 32/40CR engine types",
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"The VIT product is a reliable solution for easy retrofitting to enhance engine reliability. This solution shifts to a four-injection-timing configuration, optimizing fuel use between 50% and 65% MCR and ensuring robust engine performance with the safety of SaCoS control.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "/apps/configurators/shared/assets/pdfs/evr-ps_pmi_vit_2506.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 12,
					type: "solution",
					title: {
						en: "SaCoS retrone",
						de: "SaCoS retrone",
					},
					info: "Applicable for Everllence 32/40CD engine type",
					image:
						"/apps/configurators/shared/assets/images/content/Sacos_retrone.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						'Modernize your 32/40CD engine with SaCoS retrone, replacing outdated ABB PLC modules with an advanced SaCoS retrone system. This "Plug and Play" solution minimizes downtime and ensures a steady supply of spare parts & service. Moreover, it extends the engine lifecycle and enhances reliability and cost-effectiveness.',
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "/apps/configurators/shared/assets/pdfs/EVR_2026-SaCoSretrone_Flyer_preview_final.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 13,
					type: "solution",
					title: {
						en: "SaCoS retrone-light",
						de: "SaCoS retrone-light",
					},
					info: "Applicable for Everllence 32/40CD engine type",
					image:
						"/apps/configurators/shared/assets/images/content/Sacos_retrone.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						'Optimize your engine with SaCoS retrone-light system, a streamlined retrofit solution designed for engines with third party safety systems. This package ensures compatibility with "Plug and Play", preserves engine performance, extends engine lifetime, and guarantees a future-proof spare part supply.',
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 14,
					type: "solution",
					title: {
						en: "Electronic Checkup",
						de: "Electronic Checkup",
					},
					info: "Applicable for Everllence 32/40CR engine type",
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod-single.jpg",
					categories: [
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Ensure your Everllence 32/40 engine's peak performance with our Electronic Checkup. Conducted by our Superintendent Engineer, this service thoroughly assesses and optimizes engine functionality, focusing on efficiency, reliability, and cost-effective operation tailored to your engine's specific needs.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 15,
					type: "solution",
					title: {
						en: "ESG Retrofit - New Electronic Speed Governor",
						de: "ESG Retrofit - New Electronic Speed Governor",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/ESG_retrofit.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Retrofit your Everllence 32/40 engine with the ESG Retrofit, which introduces cutting-edge electronic speed governor technology. This retrofit elevates engine performance by optimizing speed control, improving fuel efficiency, and ensuring operational reliability. Contact our Service experts to learn more.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 16,
					type: "solution",
					title: {
						en: "Fuel Adaption Control (FAC)",
						de: "Fuel Adaption Control (FAC)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Everllence_L21-31DF-M_Gorm-Branderup0012.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"The Fuel Adaptation Control (FAC) enhances engine safety and reliability for SaCoS one and other governor controllers. It adjusts smoothly across different fuel types, reducing leakage, fuel variability and component wear issues, thus improving engine efficiency, availability, and cost savings.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 17,
					type: "solution",
					title: {
						en: "Cylinder Pressure Monitoring (CyPreMo)",
						de: "Cylinder Pressure Monitoring (CyPreMo)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/CyPreMo.jpg",
					categories: [
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"CyPreMo, our field product performance monitoring system, is a constant cylinder pressure monitor on the engine. It elevates engine wear analysis and fuel quality evaluation, boosting efficiency, reliability, and cost savings, thus protecting engine performance and improving longevity.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 18,
					type: "solution",
					title: {
						en: "Oil Mist Detector",
						de: "Oil Mist Detector",
					},
					info: "Applicable for Everllence 32/40CD engine type",
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod-single.jpg",
					categories: [
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Enhance the safety of your Everllence 32/40CD engines with our Oil Mist Detector. This essential device continuously monitors crankcase oil mist to prevent significant damages, support engine efficiency, availability, reliability, and reduce maintenance costs. It is an indispensable tool for proactive engine management.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 48,
					type: "solution",
					title: {
						en: "MMS for safety",
						de: "MMS for safety",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/MMS.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"As a complement to Multifunction Monitoring System, MMS for safety provides three optional specific modules that ensure the management of main engine safeties while the engine operation: crank pins lube oil temperature monitoring for crankshaft protection; main bearing monitoring for bearing protection and pressure monitoring for crankcase protection.<br><br>Sensors detect over deviation and active alarm or immediate stop order. That’s an additional range of modules to Multifunction Monitoring System. Modules are activated according to the operator’s needs.<br><br>The material is safety qualified for engine stops for marine applications: CE, BV, DNV, DNV-GL, GL, RS, LR, RINA, ABS, RMRS, CCS, KR, NK.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about MMS for safety",
								de: "More about MMS for safety",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multifunction-monitoring-systems",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 49,
					type: "solution",
					title: {
						en: "Multifunction Monitoring System (MMS)",
						de: "Multifunction Monitoring System (MMS)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/MMS.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Multifunction Monitoring System provides in a unique panel, the monitoring management system of the crucial operating data of the running engine and its auxiliaries.<br><br>Thanks to six complementary sources of data, MMS monitors the health and the behavior of the engine and its auxiliaries that are experiencing high strain and are central for global engine efficiency.<br><ul><li>Compliance: CE, Bureau Veritas, DNV, GL, KR, CCS, ABS, RINA</li></ul>",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about Multifunction Monitoring System",
								de: "More about Multifunction Monitoring System",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multifunction-monitoring-systems",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 50,
					type: "solution",
					title: {
						en: "MFM for lube oil (Multi Fluid Monitor)",
						de: "MFM for lube oil (Multi Fluid Monitor)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/MFM.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Everllence Multi Fluid Monitor for lube oil constantly monitors the lube oil. Using truly autonomous intelligence, it analyses the lube oil, detects anomalies and alerts the operator of any deviations. It provides a global view of all the operational lube oil parameters.<br><br>The solution is integrated into the main lube oil system of the equipment.<br><br>All types of four-stroke engines and two-stroke engines (system oil only) – Everllence and other brands, engine auxiliaries.<br><br>Everllence Multi Fluid Monitor for lube oil meets CE standards, has the following certifications:<ul><li>Marine: BV, ABS</li><li>Navy: NNO6630145997886, IEC shocks standards</li><li>Cyber Security: BV IACS UR E27</li></ul>",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about Multi Fluid Monitor",
								de: "More about Multi Fluid Monitor",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multi-fluid-monitor",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 43,
			type: "solution",
			title: {
				en: "Operation & Performance",
				de: "Operation & Performance",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 11,
					type: "solution",
					title: {
						en: "Engine Part Load Optimization (EPLO)",
						de: "Engine Part Load Optimization (EPLO)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/EPLO.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Maximize Everllence 32/40 engine performance with Engine Part Load Optimization (EPLO), including a VIT Replacement kit. It boosts efficiency at part load, aligning output with demand for fuel savings, reliability, and lower costs, positively impacting your CII rating and CO₂ emissions.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 19,
					type: "solution",
					title: {
						en: "SCR Customized Retrofit",
						de: "SCR Customized Retrofit",
					},
					info: "Applicable for Everllence 32/40CD and 32/40CR engine types",
					image:
						"/apps/configurators/shared/assets/images/content/scr_retrofit.jpg",
					categories: [
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"With the SCR Customized Retrofit for Everllence 32/40CD and 32/40CR engines, you can achieve Tier 3 NOₓ compliance. This retrofit significantly lowers NOₓ emissions by up to 95%, adapts to various operational needs and regulations, and ensures environmental adherence and operational efficiency.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 20,
					type: "solution",
					title: {
						en: "32/40 TIER II Upgrade",
						de: "32/40 TIER II Upgrade",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Tier_II_upgrade.jpg",
					categories: [
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The 32/40 TIER II Upgrade enhances your engine to TIER II NOₓ levels, improving fuel efficiency, especially at low loads. The upgrade is designed for seamless integration during overhauls and ensures compliance with regulations.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/primeserv/retrofit---upgrade---regulations/3010-0529_l3_evr-ps-eplo-factsheet.pdf?sfvrsn=4a791e51_3",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 21,
					type: "solution",
					title: {
						en: "Low Sulphur Fuel Upgrade",
						de: "Low Sulphur Fuel Upgrade",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Low_sulphur_operation_package.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The Low Sulphur Fuel Upgrade for all 32/40 engines ensures SOₓ compliance, enhancing fuel adaptability with minimal lubricity and viscosity issues. It extends engine life, maintains low-sulfur fuel performance, and significantly reduces fuel-induced contamination, optimizing operations in regulated zones.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 31,
			type: "service",
			title: {
				en: "PrimeServ Assist",
				de: "PrimeServ Assist",
			},
			info: "Applicable for all Everllence 32/40 engine types",
			image:
				"/apps/configurators/shared/assets/images/content/PrimeServ_Assist.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
				{
					en: "Emission Reduction",
					de: "Emissionsreduzierung",
				},
			],
			engines: [],
			description:
				"PrimeServ Assist, powered by Everllence CEON, is a proactive service that identifies anomalies and provides essential operational and maintenance insights. It helps reduce operational expenses and increase uptime, making maintenance planning more predictable. Precise data informs you early about potential issues.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Download Brochure",
						de: "Download Brochure",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/primeserv-assist#download",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "Explore PrimeServ Assist",
						de: "Explore PrimeServ Assist",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/primeserv-assist",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 32,
			type: "service",
			title: {
				en: "PrimeServ Lab",
				de: "PrimeServ Lab",
			},
			info: "Applicable for all Everllence 32/40 engine types",
			image:
				"/apps/configurators/shared/assets/images/content/PrimeServ_Lab.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Reliability",
					de: "Verlässlichkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
			],
			engines: [],
			description:
				"Analyze all your engine fluids to optimize operation and prevent damage with our PrimeServ Lab. It quickly delivers expert analysis and actionable insights. This solution is part of proactive maintenance and enhances engine performance and reliability, and thus reduces costs.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
			],
			children: [],
		},
		{
			id: 33,
			type: "service",
			title: {
				en: "Original Spare Parts",
				de: "Original Spare Parts",
			},
			info: "Applicable for all Everllence 32/40 engine types",
			image: "/apps/configurators/shared/assets/images/content/Spare_parts.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
			],
			engines: [],
			description:
				"Ensure peak performance for your Everllence 32/40 engines with Original Spare Parts by Everllence Energy Solutions. These spare parts protect your investment while enhancing efficiency. Opt for safety and precision with original parts. For tailored assistance, reach out to our Service experts.",
			links: [
				{
					text: {
						en: "Contact us for tailor-made solutions",
						de: "Kontakt aufnehmen",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Get the Spare Parts Brochure",
						de: "Get the Spare Parts Brochure",
					},
					url: "https://www.everllence.com/docs/default-source/services-factsheets/145879-everllence-spare-parts-essentials-brochure-5.pdf?sfvrsn=8b291f61_3",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "Explore Spare Parts",
						de: "Explore Spare Parts",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/spare-parts",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 51,
			type: "service",
			title: {
				en: "CEON TechBot",
				de: "CEON TechBot",
			},
			info: "Applicable for Everllence 32/40 engine types",
			image:
				"/apps/configurators/shared/assets/images/content/evr_ceon_techbot.png",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
			],
			engines: [],
			description:
				"Rapid and accurate answers for operational problem-solving<br><br>CEON TechBot helps you quickly find reliable information in a fast-changing world of technology, regulations, and complex documentation. Get instant, trustworthy answers whenever you need them.",
			links: [
				{
					text: {
						en: "Contact us",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Download Brochure",
						de: "Download Brochure",
					},
					url: "https://www.everllence.com/docs/default-source/services-factsheets/ceon-techbot-fact-sheet.pdf?sfvrsn=d33981f9_10",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "Explore CEON TechBot",
						de: "Explore CEON TechBot",
					},
					url: "https://www.everllence.com/services/campaigns/ceon-techbot",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 52,
			type: "service",
			title: {
				en: "EyeTech",
				de: "EyeTech",
			},
			info: "Applicable for Everllence 32/40 engine types",
			image: "/apps/configurators/shared/assets/images/content/evr_eyetech.png",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
			],
			engines: [],
			description:
				"<b>Rapid and accurate answers for operational problem-solving – Expert support, wherever you are.</b><br><br>EyeTech connects you directly with OEM experts via live video call, helping you resolve issues faster and reduce downtime. No special hardware required just a device with a camera, microphone, and internet connection.",
			links: [
				{
					text: {
						en: "Contact us",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Download Brochure",
						de: "Download Brochure",
					},
					url: "https://www.everllence.com/docs/default-source/services-factsheets/eye-tech-factsheet.pdf?sfvrsn=776f02b5_5",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "Explore EyeTech",
						de: "Explore EyeTech",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/eyetech",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 34,
			type: "service",
			title: {
				en: "Everllence PrimeServ Academies",
				de: "Everllence PrimeServ Academies",
			},
			info: "Applicable for all Everllence 32/40 engine types",
			image: "/apps/configurators/shared/assets/images/content/Academies.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Reliability",
					de: "Verlässlichkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
			],
			engines: [],
			description:
				"Explore our premium training solutions tailored for Everllence 32/40 engines, offering a perfect blend of theoretical knowledge and practical skills. Each business is unique, and we accommodate your specific requirements. Connect with our Everllence PrimeServ Academies experts to select the ideal course for your needs.",
			links: [
				{
					text: {
						en: "Contact our Academy experts",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Explore PrimeServ Academies",
						de: "Explore PrimeServ Academies",
					},
					url: "https://www.everllence.com/services/primeserv-academy",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 44,
			type: "service",
			title: {
				en: "Maintenance & Service Agreements",
				de: "Maintenance & Service Agreements",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 22,
					type: "service",
					title: {
						en: "LTSA - Standard Maintenance Agreement (SMA)",
						de: "LTSA - Standard Maintenance Agreement (SMA)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions.  The Standard Maintenance Agreement for Everllence 32/40 engines minimizes downtime and operational costs through proactive maintenance. We tailor service agreements to help you optimize the operational cost and budget reliability of preventive and conditioned-based maintenance. Get access to our Service experts at all times.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 23,
					type: "service",
					title: {
						en: "LTSA - Spare Parts Agreement (SPA)",
						de: "LTSA - Spare Parts Agreement (SPA)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions.  LTSA - Spare Parts Agreement for Everllence 32/40 engines ensures timely spare part deliveries for scheduled maintenance. This first level of LTSA provides preferred pricing, reduced admin effort, and Everllence's on-time delivery commitment, enhancing operational efficiency and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 24,
					type: "service",
					title: {
						en: "LTSA - Condition Assessment (CA) Options",
						de: "LTSA - Condition Assessment (CA) Options",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions.  Optimize maintenance with LTSA - Condition Assessment Options for Everllence 32/40 engines, featuring diagnostic tools and remote monitoring by Everllence specialist. This approach ensures early detection for proactive maintenance and quick troubleshooting, minimizing downtime.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 25,
					type: "service",
					title: {
						en: "LTSA - Uptime Optimization (UO) Options",
						de: "LTSA - Uptime Optimization (UO) Options",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions.  LTSA - Uptime Optimization (UO) Options for Everllence 32/40 engines enhance uptime, offering rapid maintenance and fast response to unplanned events. Benefits include reduced downtime, strategic spare part pricing, Everllence maintenance crews, and guaranteed response times in case of emergencies.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 26,
					type: "service",
					title: {
						en: "Maintenance interval (TBO extension)",
						de: "Maintenance interval (TBO extension)",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Guangopolo.jpg",
					categories: [
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Maximize operational efficiency with our TBO extension for Everllence 32/40 engines. This solution significantly reduces long-term operational costs and extends maintenance intervals, ensuring your engines to perform optimally longer.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about TBO Extension",
								de: "More about TBO Extension",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/tbo-extension",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 45,
			type: "service",
			title: {
				en: "Operation Agreements",
				de: "Operation Agreements",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 28,
					type: "service",
					title: {
						en: "O&M - Full Operation and Maintenance Agreement",
						de: "O&M - Full Operation and Maintenance Agreement",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/o_m.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The Full Operation & Maintenance Agreement offers a turnkey solution for managing and maintaining your power plant facilities. This comprehensive service ensures the 24/7 operation of your facility with proven practices and global support, optimizing performance and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 29,
					type: "service",
					title: {
						en: "O&M Management Agreement",
						de: "O&M Management Agreement",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/o_m.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The O&M Management Agreement places Everllence PrimeServ O&M specialists within your team for complete power plant management. It encompasses staffing, setups, and maintenance systems. Benefit from comprehensive facility management, mentoring, and spare parts supply, all aimed at boosting plant performance and efficiency.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 30,
					type: "service",
					title: {
						en: "O&M Support Agreement",
						de: "O&M Support Agreement",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image: "/apps/configurators/shared/assets/images/content/o_m.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The O&M Support Agreement enhances power plant operations with Everllence PrimeServ O&M`s expert management, maintenance, and operations guidance. This service ensures contractual compliance and offers additional benefits such as OEM spare parts management, on-site professional support, and mentoring.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 46,
			type: "service",
			title: {
				en: "Maintenance",
				de: "Maintenance",
			},
			info: "",
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 35,
					type: "service",
					title: {
						en: "Tools on Loan",
						de: "Tools on Loan",
					},
					info: "Applicable for all Everllence 32/40 engine types",
					image:
						"/apps/configurators/shared/assets/images/content/Tools_on_loan.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Enhance maintenance safety for Everllence 32/40 engines with Tools on Loan from Everllence PrimeServ. Rent the precise tools needed for efficient repairs, ensuring reliability and availability without the overhead of ownership. This service streamlines the maintenance process, safeguarding both performance and personnel.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 36,
					type: "service",
					title: {
						en: "New Tools Update",
						de: "New Tools Update",
					},
					info: "Applicable for Everllence 32/40CD, 32/40CR and 32/40DF engine types",
					image: "/apps/configurators/shared/assets/images/content/Puffer1.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"The New Tools Update for Everllence 32/40 engines introduces a modified maintenance tool to enhance operational efficiency. Preventing stud breakage saves working hours and reduces cost while improving engine availability and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 37,
					type: "service",
					title: {
						en: "Package for valve seat lube oil system",
						de: "Package for valve seat lube oil system",
					},
					info: "Applicable for Everllence 32/40CD engine type",
					image: "/apps/configurators/shared/assets/images/content/Puffer2.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Enhance your Everllence 32/40CD engines with our Valve Seat Lube Oil System Package. This upgrade boosts engine reliability and availability, extending lifespan with improved lubrication. For further information and tailored solutions, please contact our Service experts.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
	],
	pluses: [
		// Parent ID for typeItemId
		{
			id: 1,
			x: 25,
			y: 19,
			text: "Turbocharger",
			typeItemId: 38,
			type: "solution",
			direction: "right",
		},
		{
			id: 2,
			x: 40,
			y: 25,
			text: "Cylinder head",
			typeItemId: 40,
			type: "solution",
			direction: "right",
		},
		{
			id: 3,
			x: 45,
			y: 35.5,
			text: "Fuel injection system",
			typeItemId: 41,
			type: "solution",
			direction: "right",
		},
		{
			id: 4,
			x: 38.3,
			y: 44.9,
			text: "Connection rod & piston",
			typeItemId: 39,
			type: "solution",
			direction: "right",
		},
		{
			id: 5,
			x: 24.8,
			y: 44.3,
			text: "Automation & engine control system",
			typeItemId: 42,
			type: "solution",
			direction: "right",
		},
		{
			id: 6,
			x: 89,
			y: 53,
			text: "Operation Agreements",
			typeItemId: 45,
			type: "service",
			direction: "left",
		},
		{
			id: 7,
			x: 78.143,
			y: 69,
			text: "Maintenance & Service Agreements",
			typeItemId: 44,
			type: "service",
			direction: "left",
		},
		{
			id: 8,
			x: 67.286,
			y: 73,
			text: "Operation & Performance",
			typeItemId: 43,
			type: "solution",
			direction: "left",
		},
		{
			id: 9,
			x: 13,
			y: 71,
			text: "PrimeServ Assist",
			typeItemId: 31,
			type: "service",
			direction: "right",
		},
		{
			id: 10,
			x: 23.857,
			y: 75,
			text: "Original Spare Parts",
			typeItemId: 33,
			type: "service",
			direction: "right",
		},
		{
			id: 11,
			x: 56.429,
			y: 75.6,
			text: "Everllence PrimeServ Academies",
			typeItemId: 34,
			type: "service",
			direction: "right",
		},
		{
			id: 12,
			x: 34.714,
			y: 77,
			text: "CEON TechBot",
			typeItemId: 51,
			type: "service",
			direction: "right",
		},
		{
			id: 13,
			x: 45.571,
			y: 77,
			text: "EyeTech",
			typeItemId: 52,
			type: "service",
			direction: "right",
		},
	],
	engines: [
		{
			id: 1,
			type: null,
			image: "/apps/configurators/shared/assets/images/32-40.png",
			text: {
				en: "32/40",
				de: "32/40",
			},
		},
	],
	navigation: [
		{
			key: "solution",
			title: {
				en: "Solutions",
				de: "Solutions",
			},
			panelItems: [38, 39, 40, 41, 42, 43],
		},
		{
			key: "service",
			title: {
				en: "Services",
				de: "Services",
			},
			panelItems: [31, 33, 51, 52, 34, 44, 45],
		},
	],
};
